import Button from '@jetbrains/ring-ui-built/components/button/button'
import {ControlsHeight} from '@jetbrains/ring-ui-built/components/global/controls-height'
import {IconButton} from '@jetbrains/teamcity-ui/dist/components'
import classNames from 'classnames'

import TransformText from '../../../containers/TransformText'
import {useDistanceToNow} from '../../../hooks/useTimeSelector'
import {useUserDisplayName} from '../../../hooks/useUserDisplayName'
import type {User} from '../../../services/rest'
import type {BuildTypeId} from '../../../types'
import CommentPopup from '../CommentPopup/CommentPopup'

import styles from './BuildCommentByIcon.module.css'

export type BuildCommentByIconProps = {
  text: string | null | undefined
  timestamp?: string | null | undefined
  user?: User | undefined
  className?: string
  inline?: boolean
  buildTypeId?: BuildTypeId | null | undefined
  size?: 'S' | 'M'
  onEditComment?: () => void
}

function BuildCommentByIcon({
  text,
  timestamp,
  user,
  className,
  inline,
  buildTypeId,
  size = 'S',
  onEditComment,
}: BuildCommentByIconProps) {
  const userDisplayName = useUserDisplayName(user, true)
  const wrapperClasses = classNames(styles.wrapper, className)
  const timestampFromNow = useDistanceToNow(timestamp)
  if (text == null) {
    return null
  }

  const anchor = (
    <IconButton
      icon={`comment${size === 'M' ? '-20px' : ''}`}
      title=""
      aria-label="Comment"
      className={styles.button}
    />
  )
  const action = onEditComment ? (
    <Button primary className={styles.action} height={ControlsHeight.M} onClick={onEditComment}>
      {'Edit comment'}
    </Button>
  ) : null

  return (
    <div className={wrapperClasses} data-test="build-comment-wrapper">
      {inline !== true && (
        <CommentPopup
          anchor={anchor}
          timestamp={timestamp}
          user={userDisplayName}
          text={text}
          buildTypeId={buildTypeId}
          actionTitle={onEditComment ? 'Commented' : undefined}
          actions={action}
        />
      )}
      {inline === true && (
        <TransformText
          className={styles.text}
          text={text}
          buildTypeId={buildTypeId}
          lines={3}
          lineHeight={16}
        />
      )}
      {inline === true && userDisplayName != null && timestampFromNow != null && (
        <span className={styles.info}>
          <span className={styles.user}>{userDisplayName}</span>
          <span className={styles.inlineCommentText}>{`${timestampFromNow}`}</span>
        </span>
      )}
    </div>
  )
}

export default BuildCommentByIcon
